import { Redirect } from "react-router-dom"

import AuditoriaList from "pages/Auditoria/AuditoriaList"
import ForgetPassword from "pages/Authentication/ForgetPassword"
import CanalAtendimento from "pages/Configuração/CanalAtendimento/CanalAtendimento"
import StatusEventos from "pages/Configuração/Eventos/Status/StatusEventos"
import StatusSafra from "pages/Configuração/Eventos/StatusSafra/StatusSafra"
import Fabricas from "pages/Configuração/Fabricas/Fabricas"
import FilaAtendimento from "pages/Configuração/FilaAtendimento/FilaAtendimento"
import Produtos from "pages/Configuração/Produtos/Produtos"
import Steps from "pages/Configuração/Steps/Steps"
import TipoChamado from "pages/Configuração/TipoChamado/TipoChamado"
import Templates from "pages/Exportação/Templates"
import LandingPage from "pages/Landing Page/LandingPage"
import Atendimento from "../pages/Atendimento/Atendimento"
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import PasswordChange from "../pages/Authentication/PasswordChange"
import Chamados from "../pages/Chamados"
import Courrier from "../pages/Configuração/Courrier/Courrier"
import Eventos from "../pages/Configuração/Eventos/Eventos"
import ListaTransportadoras from "../pages/Configuração/Eventos/ListaTransportadoras"
import UpdateEvento from "../pages/Configuração/Eventos/UpdateEvento"
import Perfis from "../pages/Configuração/Perfis/Perfis"
import Status from "../pages/Configuração/Status/Status"
import Usuarios from "../pages/Configuração/Usuarios/Usuarios"
import Exportação from "../pages/Exportação/Exportação"
import AguardandoEmbossing from "../pages/Indicadores/AguardandoEmbossing/AguardandoEmbossing"
import Distribuicoes from "../pages/Indicadores/Distribuicoes/Distribuicoes"
import Eficiencia from "../pages/Indicadores/Eficiencia/Eficiencia"
import Indicadores from "../pages/Indicadores/Resumo/Indicadores"
import TempoMedio from "../pages/Indicadores/TempoMedio/TempoMedio"
import Detalhes from "../pages/Rastreio/DetalhesRastreio"
import Rastreio from "../pages/Rastreio/Rastreio"

import Page404 from "pages/Utilidades/Page404"
import MonitoramentoJobs from "pages/MonitoramentoJobs/MonitoramentoJobs"

const authProtectedRoutes = [
  {
    path: "/indicadores",
    component: Indicadores,
    requiredRoles: ["indicadores"],
    exact: true,
  },

  {
    path: "/indicadores/distribuicoes",
    component: Distribuicoes,
    requiredRoles: ["indicadores"],
    exact: true,
  },

  {
    path: "/indicadores/embossing",
    component: AguardandoEmbossing,
    requiredRoles: ["indicadores"],
    exact: true,
  },

  // {
  //   path: "/indicadores/devolucoes",
  //   component: Devoluções,
  //   requiredRoles: ["indicadores"],
  //   exact: true,
  // },

  {
    path: "/indicadores/tempo-medio",
    component: TempoMedio,
    requiredRoles: ["indicadores"],
    exact: true,
  },

  {
    path: "/indicadores/eficiencia",
    component: Eficiencia,
    requiredRoles: ["indicadores"],
    exact: true,
  },

  // {
  //   path: "/atendimento",
  //   component: Atendimento,
  //   requiredRoles: ["atendimento"],
  //   exact: true,
  // },

  {
    path: "/rastreio",
    component: Rastreio,
    requiredRoles: ["rastreio"],
    exact: true,
  },

  {
    path: "/rastreio/exportacao",
    component: Exportação,
    requiredRoles: ["rastreio"],
    exact: true,
  },
  {
    path: "/rastreio/exportacao/templates",
    component: Templates,
    requiredRoles: ["rastreio"],
    exact: true,
  },
  {
    path: "/rastreio/exportacao/templates/:id",
    component: Templates,
    requiredRoles: ["rastreio"],
    exact: true,
  },

  {
    path: "/pedidos/:id",
    component: Detalhes,
    requiredRoles: ["rastreio"],
    exact: true,
  },

  {
    path: "/chamados",
    component: Chamados,
    requiredRoles: ["chamado"],
    exact: true,
  },

  {
    path: "/monitoramento-jobs",
    component: MonitoramentoJobs,
    requiredRoles: ["monitoramento"],
    exact: true,
  },

  {
    path: "/configuracoes/auditoria",
    component: AuditoriaList,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/operacoes/courrier",
    component: Courrier,
    requiredRoles: ["rastreio"],
    exact: true,
  },

  {
    path: "/configuracoes/operacoes/status",
    component: Status,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/acessos/usuarios",
    component: Usuarios,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/acessos/usuarios/:id",
    component: Usuarios,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/acessos/perfis",
    component: Perfis,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/acessos/perfis/:id",
    component: Perfis,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/params/transportadoras",
    component: ListaTransportadoras,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/params/transportadoras/:id",
    component: Eventos,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/params/transportadoras/:idt/editar/:id",
    component: UpdateEvento,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/params/status-safra",
    component: StatusSafra,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/params/statuses",
    component: StatusEventos,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/atendimento/canais-de-atendimento",
    component: CanalAtendimento,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/atendimento/filas-de-atendimento",
    component: FilaAtendimento,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/atendimento/steps",
    component: Steps,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/atendimento/tipo-de-chamado",
    component: TipoChamado,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/params/produtos",
    component: Produtos,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/configuracoes/params/fabricas",
    component: Fabricas,
    requiredRoles: ["configuracoes"],
    exact: true,
  },

  {
    path: "/atendimento/:id",
    component: Atendimento,
    requiredRoles: ["atendimento", "rastreio"],
    exact: true,
  },

  { path: "/password/update", component: PasswordChange, exact: true },

  { path: "/no-profiles", component: LandingPage, exact: true },

  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/indicadores" />,
  },

  { path: "*", component: Page404 },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/redefinir-senha", component: ForgetPassword },
]

export { authProtectedRoutes, publicRoutes }
